document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.panda-produto-main');
  if (!root) return;

  var variantsJsonEl = root.querySelector('[data-variants-json]');
  var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
  var optionSelects = root.querySelectorAll('[data-option-select]');
  var variantIdInput = root.querySelector('[data-selected-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var comparePriceEl = root.querySelector('[data-compare-price]');
  var parcelEl = root.querySelector('[data-parcel]');
  var pixEl = root.querySelector('[data-pix]');
  var buyBtn = root.querySelector('[data-buy-btn]');
  var pixPercent = parseFloat(root.dataset.pixPercent || '10');
  var showPix = root.dataset.showPix === 'true';
  var installmentsCount = parseFloat(root.dataset.installmentsCount || '3');
  var stickyPriceEl = root.querySelector('[data-sticky-price]');
  var stickyParcelEl = root.querySelector('[data-sticky-parcel]');

  function moneyFromCents(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function findMatchingVariant() {
    var selected = Array.prototype.map.call(optionSelects, function (s) {
      return s.value;
    });
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selected[i];
      });
    });
  }

  function updateForVariant(variant) {
    if (!variant) {
      if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.textContent = root.dataset.unavailableLabel;
      }
      return;
    }
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFromCents(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = moneyFromCents(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    if (parcelEl) parcelEl.textContent = root.dataset.installmentsLabel + ' ' + moneyFromCents(variant.price / installmentsCount);
    if (pixEl && showPix) pixEl.textContent = moneyFromCents(variant.price * (1 - pixPercent / 100)) + ' ' + root.dataset.pixLabel.replace('[percent]', pixPercent);
    if (buyBtn) {
      buyBtn.disabled = !variant.available;
      buyBtn.textContent = variant.available ? root.dataset.buyLabel : root.dataset.unavailableLabel;
    }
    if (stickyPriceEl) stickyPriceEl.textContent = moneyFromCents(variant.price);
    if (stickyParcelEl) stickyParcelEl.textContent = root.dataset.installmentsLabel + ' ' + moneyFromCents(variant.price / installmentsCount);
    var stickyBuyBtn = root.querySelector('[data-sticky-buy-btn]');
    if (stickyBuyBtn) {
      stickyBuyBtn.disabled = !variant.available;
      stickyBuyBtn.textContent = variant.available ? root.dataset.buyLabel : root.dataset.unavailableLabel;
    }
    if (variant.featured_media) {
      var targetSlide = root.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media.id + '"]');
      if (targetSlide) goToSlide(Array.prototype.indexOf.call(slides, targetSlide));
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      updateForVariant(findMatchingVariant());
    });
  });

  // Gallery — slider via transform (sem scroll nativo), com drag/swipe próprios (mouse + touch)
  var track = root.querySelector('[data-gallery-track]');
  var slides = root.querySelectorAll('[data-gallery-slide]');
  var thumbs = root.querySelectorAll('[data-gallery-thumb]');
  var prevBtn = root.querySelector('[data-gallery-prev]');
  var nextBtn = root.querySelector('[data-gallery-next]');
  var currentIndex = 0;

  // Efeito de loading/shimmer enquanto a imagem do slide não termina de carregar
  slides.forEach(function (slide) {
    var img = slide.querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('panda-is-loaded');
    } else {
      img.addEventListener('load', function () {
        img.classList.add('panda-is-loaded');
      });
    }
  });

  function applyTrackTransform(percent, animate) {
    track.style.transition = animate ? 'transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    track.style.transform = 'translateX(' + percent + '%)';
  }

  function goToSlide(index) {
    if (index < 0 || index >= slides.length) index = currentIndex;
    currentIndex = index;
    applyTrackTransform(-100 * currentIndex, true);
    thumbs.forEach(function (t, i) {
      t.classList.toggle('panda-is-active', i === index);
    });
    var activeThumb = thumbs[currentIndex];
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      goToSlide(i);
    });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex + 1); });

  // Tira de miniaturas — arrasta com o mouse (utilitário compartilhado) e ganha
  // setinhas quando a quantidade de miniaturas transborda o espaço visível
  // (antes só rolava via touch/scroll nativo, sem nenhuma pista visual disso).
  var thumbsTrack = root.querySelector('[data-gallery-thumbs-track]');
  var thumbsPrevBtn = root.querySelector('[data-thumbs-prev]');
  var thumbsNextBtn = root.querySelector('[data-thumbs-next]');
  if (thumbsTrack) {
    if (window.pandaEnableDragScroll) window.pandaEnableDragScroll(thumbsTrack);

    function updateThumbsNav() {
      var hasOverflow = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 2;
      if (thumbsPrevBtn) thumbsPrevBtn.classList.toggle('panda-is-visible', hasOverflow);
      if (thumbsNextBtn) thumbsNextBtn.classList.toggle('panda-is-visible', hasOverflow);
    }
    updateThumbsNav();
    window.addEventListener('resize', updateThumbsNav);

    if (thumbsPrevBtn) {
      thumbsPrevBtn.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: -160, behavior: 'smooth' });
      });
    }
    if (thumbsNextBtn) {
      thumbsNextBtn.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: 160, behavior: 'smooth' });
      });
    }
  }

  // Lightbox
  var lightbox = document.getElementById('panda-pm-lightbox');
  var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
  var lightboxCounter = lightbox ? lightbox.querySelector('[data-lightbox-counter]') : null;
  var lightboxPrevBtn = lightbox ? lightbox.querySelector('[data-lightbox-prev]') : null;
  var lightboxNextBtn = lightbox ? lightbox.querySelector('[data-lightbox-next]') : null;
  var lightboxIndex = 0;

  if (lightboxImg) {
    lightboxImg.addEventListener('load', function () {
      lightboxImg.classList.add('panda-is-loaded');
    });
  }

  function showLightboxSlide(index) {
    if (index < 0 || index >= slides.length) return;
    lightboxIndex = index;
    var slide = slides[lightboxIndex];
    var img = slide ? slide.querySelector('img') : null;
    var src = slide ? slide.dataset.lightboxSrc : null;
    if (!lightboxImg || !src) return;
    if (lightboxImg.src !== src) {
      // esconde a imagem antiga até a nova terminar de carregar, evitando
      // mostrar a imagem anterior por um instante ao trocar de slide
      lightboxImg.classList.remove('panda-is-loaded');
      lightboxImg.src = src;
    } else {
      lightboxImg.classList.add('panda-is-loaded');
    }
    lightboxImg.alt = img ? img.alt : '';
    lightboxImg.classList.remove('panda-is-zoomed');
    lightboxImg.style.transformOrigin = '';
    if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + slides.length;
    // mantém a galeria principal sincronizada com o que foi visto no lightbox
    goToSlide(lightboxIndex);
  }

  function openLightbox(index) {
    if (!lightbox || !lightboxImg) return;
    showLightboxSlide(index);
    lightbox.classList.add('panda-is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('panda-is-open');
    document.body.style.overflow = '';
    if (lightboxImg) {
      lightboxImg.classList.remove('panda-is-zoomed');
      lightboxImg.style.transformOrigin = '';
    }
  }
  if (lightbox) {
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    if (lightboxPrevBtn) {
      lightboxPrevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showLightboxSlide(lightboxIndex > 0 ? lightboxIndex - 1 : slides.length - 1);
      });
    }
    if (lightboxNextBtn) {
      lightboxNextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showLightboxSlide(lightboxIndex < slides.length - 1 ? lightboxIndex + 1 : 0);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('panda-is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxSlide(lightboxIndex > 0 ? lightboxIndex - 1 : slides.length - 1);
      if (e.key === 'ArrowRight') showLightboxSlide(lightboxIndex < slides.length - 1 ? lightboxIndex + 1 : 0);
    });
  }
  // Drag/swipe no lightbox: arrasta pra navegar entre as imagens do produto (mouse + touch)
  if (lightboxImg) {
    var lbDragDown = false;
    var lbDragMoved = false;
    var lbDragStartX = 0;
    var LB_SWIPE_THRESHOLD = 50;

    lightboxImg.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function lbDragStart(x) {
      lbDragDown = true;
      lbDragMoved = false;
      lbDragStartX = x;
    }
    function lbDragMove(x) {
      if (!lbDragDown) return;
      if (Math.abs(x - lbDragStartX) > 8) lbDragMoved = true;
    }
    function lbDragEnd(x) {
      if (!lbDragDown) return;
      lbDragDown = false;
      if (lightboxImg.classList.contains('panda-is-zoomed')) return;
      var delta = x - lbDragStartX;
      if (Math.abs(delta) > LB_SWIPE_THRESHOLD) {
        if (delta < 0) {
          showLightboxSlide(lightboxIndex < slides.length - 1 ? lightboxIndex + 1 : 0);
        } else {
          showLightboxSlide(lightboxIndex > 0 ? lightboxIndex - 1 : slides.length - 1);
        }
      }
    }

    lightboxImg.addEventListener('mousedown', function (e) {
      lbDragStart(e.pageX);
    });
    document.addEventListener('mousemove', function (e) {
      lbDragMove(e.pageX);
    });
    document.addEventListener('mouseup', function (e) {
      lbDragEnd(e.pageX);
    });

    lightboxImg.addEventListener(
      'touchstart',
      function (e) {
        lbDragStart(e.touches[0].pageX);
      },
      { passive: true }
    );
    lightboxImg.addEventListener(
      'touchmove',
      function (e) {
        lbDragMove(e.touches[0].pageX);
      },
      { passive: true }
    );
    lightboxImg.addEventListener('touchend', function (e) {
      lbDragEnd(e.changedTouches[0].pageX);
    });

    lightboxImg.addEventListener('click', function (e) {
      e.stopPropagation();
      if (lbDragMoved) return;
      var isZoomed = lightboxImg.classList.contains('panda-is-zoomed');
      if (isZoomed) {
        lightboxImg.classList.remove('panda-is-zoomed');
        lightboxImg.style.transformOrigin = '';
        return;
      }
      var rect = lightboxImg.getBoundingClientRect();
      var originX = ((e.clientX - rect.left) / rect.width) * 100;
      var originY = ((e.clientY - rect.top) / rect.height) * 100;
      lightboxImg.style.transformOrigin = originX + '% ' + originY + '%';
      lightboxImg.classList.add('panda-is-zoomed');
    });
  }

  // Drag/swipe: navega entre slides e, se for um clique real (sem arrastar), abre o lightbox
  if (track && slides.length) {
    var isDown = false;
    var moved = false;
    var startX = 0;
    var trackWidth = 1;
    var deltaPercent = 0;

    var rafId = null;
    var pendingX = null;

    function dragStart(x) {
      isDown = true;
      moved = false;
      startX = x;
      trackWidth = track.getBoundingClientRect().width || 1;
      deltaPercent = 0;
      applyTrackTransform(-100 * currentIndex, false);
    }

    function renderDragFrame() {
      rafId = null;
      if (pendingX === null || !isDown) return;
      var deltaX = pendingX - startX;
      if (Math.abs(deltaX) > 4) moved = true;
      deltaPercent = (deltaX / trackWidth) * 100;
      applyTrackTransform(-100 * currentIndex + deltaPercent, false);
    }

    function dragMove(x) {
      if (!isDown) return;
      pendingX = x;
      if (rafId === null) rafId = requestAnimationFrame(renderDragFrame);
    }

    function dragEnd() {
      if (!isDown) return;
      isDown = false;
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      track.classList.remove('panda-is-dragging');

      if (!moved) {
        goToSlide(currentIndex);
        openLightbox(currentIndex);
        return;
      }

      var targetIndex = currentIndex;
      if (Math.abs(deltaPercent) > 12) {
        targetIndex = deltaPercent < 0 ? currentIndex + 1 : currentIndex - 1;
      }
      if (targetIndex < 0 || targetIndex >= slides.length) targetIndex = currentIndex;
      goToSlide(targetIndex);
    }

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    track.addEventListener('mousedown', function (e) {
      e.preventDefault();
      track.classList.add('panda-is-dragging');
      dragStart(e.pageX);
    });
    document.addEventListener('mousemove', function (e) {
      dragMove(e.pageX);
    });
    document.addEventListener('mouseup', dragEnd);

    track.addEventListener(
      'touchstart',
      function (e) {
        track.classList.add('panda-is-dragging');
        dragStart(e.touches[0].pageX);
      },
      { passive: true }
    );
    track.addEventListener(
      'touchmove',
      function (e) {
        dragMove(e.touches[0].pageX);
      },
      { passive: true }
    );
    track.addEventListener('touchend', dragEnd);
  }

  // Add-on (solitário) selection
  var addonCards = root.querySelectorAll('[data-addon-card]');
  addonCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var alreadyActive = card.classList.contains('panda-is-active');
      addonCards.forEach(function (c) { c.classList.remove('panda-is-active'); });
      if (!alreadyActive) card.classList.add('panda-is-active');
    });
  });

  // Buy button (botão principal e o sticky reaproveitam a mesma lógica)
  // Coleta genérica de properties[...] — padrão nativo da Shopify (o mesmo que
  // FormData(form) capturaria num <form> real). Cobre qualquer app/campo futuro
  // que siga essa convenção — não é o caso do Aris/Avis (ver função abaixo),
  // mas mantém isso funcionando pra qualquer outro caso que apareça.
  function collectGenericProperties() {
    var properties = {};
    root.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match || !field.value) return;
      properties[match[1]] = field.value;
    });
    return properties;
  }

  // O Aris/Avis Product Options NÃO usa a convenção properties[...] — os campos
  // que ele renderiza dentro de .avpoptions-container__v2/.avpoptions-container
  // usam name="<Rótulo da opção>" direto (ex: name="Gravação Feminina"), com um
  // atributo próprio field-name repetindo o mesmo valor. O app também tenta se
  // conectar sozinho a um botão de "adicionar ao carrinho" via uma lista fixa de
  // seletores conhecidos (product-form__submit, button[name='add'], .add_to_cart
  // etc.) — nenhum bate com o nosso botão (data-buy-btn, sem <form>, sem
  // name="add"), então a única forma confiável de capturar os valores é ler os
  // campos direto pelo field-name, igual ao Shopify faria via FormData num tema
  // "padrão" que o Aris reconhecesse.
  //
  // Alguns campos (ex.: "Solitário escolhido:") não são só texto — são um
  // swatch vinculado a um produto/variante real (um "ghost product" que o
  // próprio Avis cria, com preço próprio), exposto via data-variant-id no
  // input marcado. Esses precisam virar um item de carrinho separado (senão
  // o solitário nunca é cobrado nem aparece no carrinho), não uma property
  // de texto — o Avis tentaria fazer isso sozinho ao interceptar o clique no
  // botão de comprar, mas cai no mesmo problema do parágrafo acima.
  //
  // O Avis também mantém, por grupo desses swatches, um campo oculto de
  // "resumo" (mesmo field-name, sem data-variant-id) com o texto já pronto
  // (ex.: "Anel Solitário Grátis,Anel Solitário Cravejado"). NÃO usamos esse
  // texto direto: ele é capturado só no momento de adicionar ao carrinho e
  // nunca mais é atualizado, então some/some errado se um dos solitários for
  // removido depois (a aliança ficaria com a property desatualizada,
  // indicando um solitário que não está mais no carrinho e não foi cobrado).
  // Em vez disso montamos essa property nós mesmos a partir de quem está
  // marcado de verdade, e marcamos cada item de bundle com o rótulo dele
  // (_panda_avis_bundle_label) e a chave de property da aliança-mãe que ele
  // pertence (_panda_avis_bundle_property_key) — assim o cart drawer
  // consegue recalcular essa property certinha sempre que um solitário for
  // removido do carrinho (ver panda-cart-drawer.js).
  function collectAvisFields(bundleOwnerId) {
    var properties = {};
    var bundleItems = [];
    var allFields = root.querySelectorAll('.avpoptions-container__v2 [field-name], .avpoptions-container [field-name]');

    var bundleGroupKeys = {};
    allFields.forEach(function (field) {
      if (field.getAttribute('data-variant-id')) {
        bundleGroupKeys[field.getAttribute('field-name')] = true;
      }
    });

    var bundleGroupLabels = {};
    allFields.forEach(function (field) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      var key = field.getAttribute('field-name');
      var variantId = field.getAttribute('data-variant-id');
      if (variantId) {
        var label = field.getAttribute('data-option-value') || field.value;
        bundleGroupLabels[key] = bundleGroupLabels[key] || [];
        bundleGroupLabels[key].push(label);
        // _panda_avis_bundle_parent usa um id gerado por compra (bundleOwnerId),
        // não o id da variante — se o cliente comprar a MESMA variante da
        // aliança duas vezes no mesmo pedido (cada uma com seu próprio
        // solitário), o id da variante sozinho não distingue qual das duas
        // linhas é a dona de qual solitário; o bundleOwnerId (marcado também
        // no item principal, ver buildBuyItems) resolve isso sem ambiguidade.
        // Usado pelo cart drawer pra travar a quantidade deste item, remover
        // o grátis junto se o produto principal for removido do carrinho, e
        // recalcular a property de resumo (_panda_avis_bundle_label /
        // _panda_avis_bundle_property_key) da aliança-mãe quando ele mesmo
        // for removido.
        bundleItems.push({
          id: variantId,
          quantity: 1,
          properties: {
            _panda_avis_bundle_parent: bundleOwnerId,
            _panda_avis_bundle_label: label,
            _panda_avis_bundle_property_key: key,
          },
        });
        return;
      }
      if (bundleGroupKeys[key]) return; // resumo oculto do próprio grupo de bundle, ignorado (ver comentário acima)
      if (!key || !field.value) return;
      properties[key] = field.value;
    });

    for (var groupKey in bundleGroupLabels) {
      properties[groupKey] = bundleGroupLabels[groupKey].join(',');
    }

    return { properties: properties, bundleItems: bundleItems };
  }

  function buildBuyItems() {
    var items = [];
    var properties = collectGenericProperties();
    // Id único desta compra específica (não o id da variante) — usado só pra
    // ligar os itens de bundle Avis (solitário) à linha certa do produto
    // principal no carrinho, mesmo se a mesma variante for comprada mais de
    // uma vez no mesmo pedido (ver collectAvisFields).
    var bundleOwnerId = 'o' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    var avisFields = collectAvisFields(bundleOwnerId);
    Object.assign(properties, avisFields.properties);
    root.querySelectorAll('[data-engraving-input]').forEach(function (input) {
      if (input.value.trim()) properties[input.dataset.engravingInput] = input.value.trim();
    });
    if (avisFields.bundleItems.length) {
      properties._panda_avis_bundle_owner = bundleOwnerId;
    }
    items.push({
      id: variantIdInput ? variantIdInput.value : variants[0].id,
      quantity: 1,
      properties: properties,
    });
    items = items.concat(avisFields.bundleItems);
    var activeAddon = root.querySelector('[data-addon-card].panda-is-active');
    if (activeAddon && activeAddon.dataset.variantId) {
      items.push({ id: activeAddon.dataset.variantId, quantity: 1 });
    }
    return items;
  }

  function handleBuyClick(btn) {
    if (btn.disabled || btn.classList.contains('panda-btn-loading')) return;
    btn.classList.add('panda-btn-loading');
    window
      .pandaAddToCart(buildBuyItems())
      .catch(function (err) {
        console.error('panda: falha ao comprar', err);
      })
      .finally(function () {
        btn.classList.remove('panda-btn-loading');
      });
  }

  root.querySelectorAll('[data-buy-btn], [data-sticky-buy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      handleBuyClick(btn);
    });
  });

  // Sticky CTA: aparece quando o hero secundário (panda-hp2) sai de vista
  var stickyCta = root.querySelector('[data-sticky-cta]');
  var stickyTrigger = document.querySelector('.panda-hp2');
  if (stickyCta && stickyTrigger) {
    window.addEventListener(
      'scroll',
      function () {
        var rect = stickyTrigger.getBoundingClientRect();
        stickyCta.classList.toggle('panda-is-visible', rect.bottom < 0);
      },
      { passive: true }
    );
  }

  // character counters for engraving fields
  root.querySelectorAll('[data-engraving-input]').forEach(function (input) {
    var counter = root.querySelector('[data-engraving-counter="' + input.dataset.engravingInput + '"]');
    if (!counter) return;
    var max = input.getAttribute('maxlength') || 20;
    input.addEventListener('input', function () {
      counter.textContent = input.value.length + '/' + max;
    });
  });
});
